import * as React from 'react';
import { Page, Pane, PaneBackButton, PaneBody, PaneHeader } from '../../atoms/applications/page';
import { ApplicationPageState } from '../../../containers/application/states/ApplicationPageState';
import { inject, observer } from 'mobx-react';
import { PlanSelector } from '../../atoms/applications/plans';
import { PlanNotice, PlanOptionSelector } from '../../atoms/applications/planOptions';
import { SelectedPlanSummary } from '../../atoms/applications/SelectedPlanSummary';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { observable, makeObservable } from 'mobx';
import { CampaignList } from '../../atoms/applications/CampaignList';
import { CouponInputForm } from '../coupons/CouponInputForm';
import './planSelectionPane.module.scss';
import { AppliedCouponSummary } from '../coupons/AppliedCouponSummary';
import { EntranceFeeSummary } from '../../atoms/applications/EntranceFeeSummary';

type Props = {
  applicationState: ApplicationPageState;
};

export const PlanSelectionPane = inject('applicationState')(
  observer(
    class PlanSelectionPane extends React.Component<Props> {
      variable = 1;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          variable: observable,
        });
      }

      render() {
        const {
          applicationState: {
            canGoBack,
            plans,
            selectedPlanId,
            selectPlan,
            selectedPlan,
            selectedItemId,
            selectedItem,
            selectItem,
            entranceFee,
            validatePlanAndNext,
            couponState,
            validateCouponCode,
            clearCoupons,
            submitState: { submitting },
          },
        } = this.props;
        return (
          <Page>
            <Pane>
              {canGoBack && <PaneBackButton />}
              <PaneHeader>プランの選択</PaneHeader>
              <PaneBody>
                <PlanSelector plans={plans.getOrElse([])} selectedPlanId={selectedPlanId} onPlanChange={selectPlan} />
                {selectedPlan && <SelectedPlanSummary plan={selectedPlan} />}
                {selectedPlan && selectedPlan.discount_campaigns.length > 0 && (
                  <CampaignList campaigns={selectedPlan.discount_campaigns} />
                )}
                {!couponState.appliedCoupon && (
                  <div styleName="coupon-form-wrapper">
                    <CouponInputForm
                      couponCodeField={couponState.couponCodeField}
                      onSubmit={validateCouponCode}
                      submitting={submitting}
                    />
                  </div>
                )}
                {couponState.appliedCoupon && (
                  <AppliedCouponSummary
                    code={couponState.appliedCoupon.code}
                    name={couponState.appliedCoupon.name}
                    description={couponState.appliedCoupon.description}
                    onRequestDelete={clearCoupons}
                  />
                )}
                {selectedPlan && (
                  <PlanOptionSelector
                    selectedItemId={selectedItemId}
                    items={selectedPlan.items}
                    onItemSelect={selectItem}
                  />
                )}
                {entranceFee && (
                  <EntranceFeeSummary
                    name={'入会金'}
                    price={entranceFee.price}
                    priceWithTax={entranceFee.price_with_tax}
                    discount={entranceFee.discount}
                    discountPrice={entranceFee.discount_price}
                    discountPriceWithTax={entranceFee.discount_price_with_tax}
                    showPlusIcon={true}
                    showHeader={false}
                  />
                )}
                <PlanNotice>
                  {entranceFee && (
                    <span>
                      ※ 別途、入会金が{entranceFee.price.toLocaleString()}円（税込{' '}
                      {entranceFee.price_with_tax.toLocaleString()}円）かかります
                      <br />
                    </span>
                  )}
                  ※ 月額料金のお支払いは、まとめてご一括のみとなります
                  <br />※ お申込日を起算日とし、自動更新されます。12ヶ月後(12ヶ月プラン) / 6ヶ月後(6ヶ月プラン) /
                  1ヶ月後(月額プラン) 各プラン自動更新されます
                </PlanNotice>
                <ButtonWrapper>
                  <SubmitButton id="plan-select-submit" disabled={selectedItem == null} onClick={validatePlanAndNext}>
                    お支払い情報の入力へ
                  </SubmitButton>
                </ButtonWrapper>
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
